import { render, staticRenderFns } from "./r-reward-package-config-table.vue?vue&type=template&id=09ae4f0a"
import script from "./r-reward-package-config-table.vue?vue&type=script&lang=js"
export * from "./r-reward-package-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ae4f0a')) {
      api.createRecord('09ae4f0a', component.options)
    } else {
      api.reload('09ae4f0a', component.options)
    }
    module.hot.accept("./r-reward-package-config-table.vue?vue&type=template&id=09ae4f0a", function () {
      api.rerender('09ae4f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-pack/r-reward-package-config-table.vue"
export default component.exports